export default __webpack_public_path__ + "static/media/fauna-db-collections.06b964f9.png";